"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcGradient = void 0;
var calcGradient = function (deg, start, end) {
    if (deg === void 0) { deg = 0; }
    if (start === void 0) { start = '#000000'; }
    if (end === void 0) { end = '#FFFFFF'; }
    return "linear-gradient(".concat(deg, "deg, ").concat(start, " 0%, ").concat(end, " 100%)");
};
exports.calcGradient = calcGradient;
//# sourceMappingURL=calc-gradient.js.map